import './style.css';

import React from 'react';
export default function BackgroundDesign({ classes, ...props }) {
  return <div className={`bg-design ${classes}`} {...props} />;
}
